import clsx from 'clsx'

import type { PropsWithClassName } from '@fv/client-types'

type PinlineProps = PropsWithClassName<{
  className?: string
  dashed?: boolean
  dotted?: boolean
  thick?: boolean
  rule?: boolean
  flex?: boolean
}>
export const Pinline = ({
  className,
  dashed,
  thick,
  dotted,
  rule,
  flex,
}: PinlineProps) => {
  return (
    <div
      className={clsx(
        'h-px border-t border-fv-gray',
        className,
        dashed && 'border-dashed',
        thick && 'border-t-2',
        dotted && 'border-dotted',
        rule && 'my-4',
        flex && 'flex-1',
      )}
    ></div>
  )
}
